module.exports = __webpack_public_path__ + "img/boss_active.c5344798.svg";